(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        var menuButton = document.querySelector('[data-menu-button]');
        var nav = document.querySelector('[data-site-nav]');

        if (menuButton && nav) {
            menuButton.addEventListener('click', function () {
                var isOpen = nav.classList.toggle('is-open');
                menuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            });

            nav.addEventListener('click', function (event) {
                if (event.target instanceof HTMLAnchorElement) {
                    nav.classList.remove('is-open');
                    menuButton.setAttribute('aria-expanded', 'false');
                }
            });
        }

        var panels = Array.prototype.slice.call(document.querySelectorAll('[data-service-panel]'));
        panels.forEach(function (panel, index) {
            var button = panel.querySelector('[data-service-toggle]');
            var body = panel.querySelector('[data-service-body]');

            if (!button || !body) {
                return;
            }

            body.hidden = index !== 0;

            button.addEventListener('click', function () {
                var willOpen = body.hidden;

                panels.forEach(function (otherPanel) {
                    var otherButton = otherPanel.querySelector('[data-service-toggle]');
                    var otherBody = otherPanel.querySelector('[data-service-body]');
                    if (otherButton && otherBody) {
                        otherBody.hidden = true;
                        otherButton.setAttribute('aria-expanded', 'false');
                    }
                });

                body.hidden = !willOpen;
                button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
            });
        });

        var slider = document.querySelector('[data-testimonial-slider]');
        if (slider) {
            var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-testimonial-slide]'));
            var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-testimonial-dot]'));
            var currentSlide = 0;
            var intervalId = null;

            var showSlide = function (index) {
                currentSlide = index;
                slides.forEach(function (slide, slideIndex) {
                    slide.classList.toggle('is-active', slideIndex === index);
                });
                dots.forEach(function (dot, dotIndex) {
                    dot.classList.toggle('is-active', dotIndex === index);
                });
            };

            var startSlider = function () {
                if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                    return;
                }
                intervalId = window.setInterval(function () {
                    showSlide((currentSlide + 1) % slides.length);
                }, 5200);
            };

            dots.forEach(function (dot, index) {
                dot.addEventListener('click', function () {
                    if (intervalId) {
                        window.clearInterval(intervalId);
                    }
                    showSlide(index);
                    startSlider();
                });
            });

            startSlider();
        }

        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            document.querySelectorAll('.wia-card, .wia-service-panel, .wia-contact-card, .wia-testimonial-slider').forEach(function (item) {
                item.animate(
                    [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }],
                    { duration: 420, easing: 'ease-out', fill: 'both' }
                );
            });
        }
    });
})();
